if (window.location.pathname.includes('/activation_code_forms')) {
  document.addEventListener("DOMContentLoaded", () => {
    generateActivationCode();
    autofillLocationIdNumber();
    setupDeviceConfigsEdit();
    toggleRequiredFields();
  });
}

function generateActivationCode() {
  const codeInput = $(`#activation_code_form_code`);
  if (!codeInput || codeInput.val()?.trim()) return;

  const letters = [...Array(3)].map(() =>
    String.fromCharCode(65 + Math.random() * 26)
  ).join('');
  const digits = Math.floor(100 + Math.random() * 900);

  codeInput.val(letters + digits);
}

function autofillLocationIdNumber() {
  let locationSelect = $(`#activation_code_form_location_id`);
  let idNumberField = $(`#activation_code_form_location_id_number`);
  if (!locationSelect || !idNumberField) return;

  locationSelect.on("change", () => {
    const selectedIndex = locationSelect[0].selectedIndex;
    if (selectedIndex !== -1) {
      const selectedOptionText = locationSelect[0].options[selectedIndex].textContent;
      const match = selectedOptionText.match(/\(([^)]+)\)/);
      idNumberField.val(match?.[1]) || "";
    }
    toggleRequiredFields();
  });

  idNumberField.on("input", () => {
    toggleRequiredFields();
  });
}

function toggleRequiredFields() {
  const idNumberField = document.querySelector("#activation_code_form_location_id_number");
  const isLocationIdBlank = !idNumberField?.value.trim();
  const fields = ["phone_number", "email"];

  fields.forEach((field) => {
    const label = document.querySelector(`label[for="activation_code_form_${field}"]`);
    if (!label) return;

    const abbr = label.querySelector("abbr");

    if (isLocationIdBlank) {
      if (!abbr) {
        const abbrElement = document.createElement("abbr");
        abbrElement.textContent = "*";
        label.appendChild(abbrElement);
      }
    } else {
      if (abbr) {
        abbr.remove();
      }
    }
  });
}

function setupDeviceConfigsEdit() {
  const editorContainer = document.getElementById("device-config-templates-editor");
  const hiddenInput = document.getElementById("device-config-templates");
  const addButton = document.getElementById("add-device-config-template");
  if (!editorContainer || !hiddenInput || !addButton) return;

  const availableTemplates = JSON.parse(editorContainer.dataset.configTemplates);
  const i18nTranslations = JSON.parse(editorContainer.dataset.i18n);
  let configTemplates = hiddenInput.value ? JSON.parse(hiddenInput.value).map(config => ({
    template_config: config.template_config || "",
    key: config.key || "",
    value: config.value || ""
  })) : [];

  function createTemplateSelect(index, config) {
    const select = document.createElement("select");
    select.className = "select2 device-config-template";
    select.dataset.index = index;
    select.innerHTML = '<option value=""></option>' +
      Object.entries(availableTemplates).map(([key, entries]) => {
        const desc = entries[0].description;
        return `<option value="${key}" data-key="${entries[0].data}">
                  ${key} - ${desc}
                </option>`;
      }).join("");
    if (config.template_config) select.value = config.template_config;
    return select;
  }

  function createInput(className, value, labelText) {
    const container = document.createElement("li");
    container.className = "string input stringish required";
    const label = document.createElement("label");
    label.className = "label";
    label.textContent = labelText;
    const input = document.createElement("input");
    input.type = "text";
    input.className = className;
    input.value = value || "";
    container.append(label, input);
    return container;
  }

  function createRemoveButton() {
    const button = document.createElement("button");
    button.type = "button";
    button.className = "button remove-device-config";
    button.textContent = i18nTranslations.delete;
    return button;
  }

  function renderTemplates() {
    editorContainer.innerHTML = "";
    configTemplates.forEach((config, index) => {
      const row = document.createElement("div");
      row.className = "device-config-row";
      row.dataset.index = index;

      const selectContainer = document.createElement("li");
      selectContainer.className = "string input stringish";
      const selectLabel = document.createElement("label");
      selectLabel.className = "label";
      selectLabel.textContent = i18nTranslations.device_config_template;
      const select = createTemplateSelect(index, config);
      selectContainer.append(selectLabel, select);

      const keyInput = createInput("device-config-key", config.key, i18nTranslations.device_config_key);
      const valueInput = createInput("device-config-value", config.value, i18nTranslations.device_config_value);
      const removeButton = createRemoveButton();

      row.append(selectContainer, keyInput, valueInput, removeButton);
      editorContainer.appendChild(row);

      $(select).select2({ width: "100%" });
      validateInput(row.querySelector(".device-config-key"), index, "key");
      validateInput(row.querySelector(".device-config-value"), index, "value");
    });
  }

  function validateInput(input, index, field) {
    const errorDiv = document.querySelector(`.device-config-row[data-index="${index}"] .error-message-${field}`);
    if (errorDiv) errorDiv.remove();
    if (!input.value) {
      const error = document.createElement("p");
      error.className = `inline-errors error-message-${field}`;
      error.textContent = i18nTranslations.blank_error;
      input.parentElement.appendChild(error);
      return false;
    }
    return true;
  }

  function parseJsonSafe(value) {
    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  }

  $(editorContainer).on("change", ".device-config-template", function() {
    const specialValuesKeys = ["currency_exchange", "white_list_devices", "tax_rates", "tax_offices", "exchange_info"];
    const select = this;
    const index = select.dataset.index;
    const selectedTemplate = select.value;
    const selectedEntry = availableTemplates[selectedTemplate]?.[0];
    const key = selectedEntry?.data || "";
    const inputValue = selectedEntry?.value || "";
    const parsedValue = parseJsonSafe(inputValue);
    const value = specialValuesKeys.includes(selectedTemplate) ? JSON.stringify(parsedValue) : inputValue;

    configTemplates[index] = {
      template_config: selectedTemplate,
      key: selectedTemplate ? key : configTemplates[index].key,
      value: selectedTemplate ? value : configTemplates[index].value,
    };

    const row = editorContainer.querySelector(`.device-config-row[data-index="${index}"]`);
    const keyInput = row.querySelector(".device-config-key");
    const valueInput = row.querySelector(".device-config-value");
    keyInput.value = configTemplates[index].key;
    valueInput.value = configTemplates[index].value;

    validateInput(keyInput, index, "key");
    validateInput(valueInput, index, "value");
    hiddenInput.value = JSON.stringify(configTemplates);
  });

  addButton.addEventListener("click", () => {
    configTemplates.push({ template_config: "", key: "", value: "" });
    hiddenInput.value = JSON.stringify(configTemplates);
    renderTemplates();
  });

  editorContainer.addEventListener("click", (e) => {
    if (e.target.classList.contains("remove-device-config")) {
      const index = e.target.closest(".device-config-row").dataset.index;
      configTemplates.splice(index, 1);
      hiddenInput.value = JSON.stringify(configTemplates);
      renderTemplates();
    }
  });

  editorContainer.addEventListener("input", (e) => {
    const target = e.target;
    if (target.classList.contains("device-config-key") || target.classList.contains("device-config-value")) {
      const index = target.closest(".device-config-row").dataset.index;
      const field = target.classList.contains("device-config-key") ? "key" : "value";
      configTemplates[index][field] = target.value;
      validateInput(target, index, field);
      hiddenInput.value = JSON.stringify(configTemplates);
    }
  });

  renderTemplates();
}
